import { render, staticRenderFns } from "./IdeaInnerContents.vue?vue&type=template&id=54fbfedb&"
import script from "./IdeaInnerContents.vue?vue&type=script&lang=js&"
export * from "./IdeaInnerContents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports